import Vue from 'vue'
import App from './land.vue'
import { Popup, Form, Field, Cascader, Button } from 'vant'
import mixins from '../../mixin/common'
import Truck from '../../plugins/index'
import store from '../../store'
import '../../assets/common.less'
// import VConsole from 'vconsole'
// var vConsole = new VConsole()
// console.log(vConsole)
Vue.use(Truck)
Vue.mixin(mixins)
Vue.use(Popup).use(Form).use(Field).use(Cascader).use(Button)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
